module.exports = __webpack_public_path__ + "media/assets/images/landings/contact_center/screens/nosco_omnichannel_inbox-4a77884359b62c4394e2a09cb3b271bf.png";